module.exports = __webpack_public_path__ + "static/media/word.7d68b0d6.svg";